export interface PointsProfile {
  id: 'dep' | 'urb' | 'bie';
  label: string;
  emoji: string;
  kmSemana: number;
  diasActivos: number;
}

export const POINTS_PROFILES: PointsProfile[] = [
  { id: 'dep', label: 'Deportista', emoji: '🚴', kmSemana: 275, diasActivos: 7 },
  { id: 'urb', label: 'Urbano', emoji: '🏙️', kmSemana: 175, diasActivos: 5 },
  { id: 'bie', label: 'Bienestar', emoji: '🌿', kmSemana: 55, diasActivos: 2 },
];

const POINTS_PER_KM = 10;

const weeklyPoints = (profile: PointsProfile): number =>
  Math.round(
    profile.kmSemana * POINTS_PER_KM +
      profile.diasActivos * 10 +
      (profile.id === 'dep' ? 400 : profile.id === 'urb' ? 200 : 100) +
      (profile.diasActivos >= 7 ? 150 : 0) +
      45
  );

export interface EaseLevel {
  pct: number;
  color: string;
  label: string;
  hint: string;
}

const URBAN_PROFILE = POINTS_PROFILES.find(profile => profile.id === 'urb');

export const getEaseLevel = (pointsCost: number): EaseLevel => {
  const weeksToRedeem = pointsCost / weeklyPoints(URBAN_PROFILE);

  if (weeksToRedeem < 1) {
    return {
      pct: 15,
      color: '#4ade80',
      label: 'Muy fácil',
      hint: 'Cualquier usuario activo lo alcanza en días. Ideal para generar tráfico frecuente.',
    };
  }
  if (weeksToRedeem < 2) {
    return {
      pct: 35,
      color: '#4ade80',
      label: 'Fácil',
      hint: 'Un usuario urbano promedio lo alcanza en menos de 2 semanas.',
    };
  }
  if (weeksToRedeem < 4) {
    return {
      pct: 55,
      color: '#FFC700',
      label: 'Moderado',
      hint: 'Requiere constancia. Filtra usuarios activos y le da más valor al canje.',
    };
  }
  if (weeksToRedeem < 8) {
    return {
      pct: 75,
      color: '#FFC700',
      label: 'Exigente',
      hint: 'Solo usuarios comprometidos van a llegar. Posicioná el beneficio como exclusivo.',
    };
  }
  return {
    pct: 95,
    color: '#f87171',
    label: 'Premium',
    hint: 'Muy pocos usuarios van a poder canjearlo. Usalo para beneficios de alto valor.',
  };
};

export const getProfileWeeksLabel = (
  pointsCost: number,
  profile: PointsProfile
): { text: string; color: string } => {
  const weeks = pointsCost / weeklyPoints(profile);

  if (weeks < 0.8) return { text: '< 1 sem', color: '#4ade80' };
  if (weeks < 1.5) return { text: '~1 sem', color: '#4ade80' };
  if (weeks < 3) return { text: `~${Math.round(weeks)} sem`, color: '#FFC700' };
  if (weeks < 6) return { text: `~${Math.round(weeks)} sem`, color: '#FFC700' };
  return { text: `+${Math.round(weeks)} sem`, color: '#f87171' };
};
